import React from 'react'
import { Route, Switch } from 'react-router-dom'

import MobileViewList from './mobileViewList'
import MobileViewDetail from './mobileViewDetail'
import '../css/App.css'

class MobileView extends React.Component {
  render () {
    return (
      <Switch>
        <Route exact path='/:username' component={MobileViewDetail} />
        <Route component={MobileViewList} />
      </Switch>
    )
  }
}

export default MobileView
